import { connect } from 'react-redux';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import { getExtraItems } from '../../store/selectors/extraitems';

import ExtraItems from '../../components/ExtraItems';

const mapStateToProps = (state) => ({
  items: getExtraItems(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(ExtraItems);
